import common from "./common.json"

const french = {
    "translation": {
        "Common": common,
    }
}

export default french